import "core-js/modules/es.array.push.js";
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "ya-order-wrapper"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  class: "ya-order-wrapper-item-icon"
};
const _hoisted_4 = {
  class: "ya-order-wrapper-item-icon-mark"
};
const _hoisted_5 = ["src"];
import constants from '@/constants';
import { isLoginAuthenticated } from '@/utils/common';
import { reactive, watch } from 'vue';
import { useRouter } from 'vue-router';
import { awsRumHandler } from '@/utils/awsRumHandler.js';
import { clickEvents } from '@/configs/awsRumConfig';
import { YourAccount } from '@/assets/marketplaces/cn/configs';
import { useLess } from '@/models/hooks';
export default {
  __name: 'YAOrder',
  props: {
    isLogin: Boolean,
    toBeCommentedCount: Number
  },
  emits: ['update:isLogin'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    useLess('views/yourAccount/components/YAOrder.less');
    const router = useRouter();
    const orderCount = reactive({
      noShipmentCount: 0,
      deliveryingCount: 0,
      toBeCommentedCount: 0,
      afterSaleCount: 0,
      totalOrderCount: 0
    });
    const jumpToPage = async (routerName, status, key) => {
      if (YourAccount.CLICK_EVENTS_MAPPINGS[key]) {
        awsRumHandler.recordClickEvent(clickEvents.yourAccountPage[YourAccount.CLICK_EVENTS_MAPPINGS[key]]);
      }
      // status: 1-All Orders 2-To be shipped 3-To be received
      await isLoginAuthenticated();
      const isLoginStatus = await isLoginAuthenticated(false);
      emit('update:isLogin', isLoginStatus);
      if (!isLoginStatus) return;
      if (routerName === 'asList') {
        router.push({
          name: routerName
        });
      } else {
        router.push({
          name: routerName,
          params: {
            status
          }
        });
      }
    };
    watch(props, propsObj => {
      if (propsObj.isLogin) {
        if (propsObj.toBeCommentedCount) {
          orderCount.toBeCommentedCount = propsObj.toBeCommentedCount;
        }
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(constants).YA_ORDER_TABS, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          onClick: $event => jumpToPage(item.PATH, item.PARAMS, item.KEY),
          class: "ya-order-wrapper-item"
        }, [_createElementVNode("div", _hoisted_3, [_withDirectives(_createElementVNode("div", _hoisted_4, " ... ", 512), [[_vShow, orderCount[item.KEY]]]), _createElementVNode("img", {
          src: item.ICON,
          draggable: "false"
        }, null, 8, _hoisted_5)]), _createElementVNode("span", null, _toDisplayString(item.NAME), 1)], 8, _hoisted_2);
      }), 128))])]);
    };
  }
};